import styled from 'styled-components';

export const FooterStyles = styled.div`
.vl1 {
  border-left: 6px solid black;
  height: 100%;
  position: absolute;
  left: 5%;
  margin-left: 4%;
  bottom: 0;

  border-right: 6px solid black;
  height: 100%;
  position: absolute;
  right: 5%;
  margin-right: 4%;
  bottom: 0;
}
`